import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { FluxoCaixaPeriodo } from '../types/fluxoCaixa';

const { RangePicker } = DatePicker;

interface FluxoCaixaResumoPeriodoProps {
  periodo: FluxoCaixaPeriodo;
  onChange: (periodo: FluxoCaixaPeriodo) => void;
}

export function FluxoCaixaResumoPeriodo({ periodo, onChange }: FluxoCaixaResumoPeriodoProps) {
  const handleChange = (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => {
    if (!dates || !dates[0] || !dates[1]) return;
    onChange({
      dataInicio: dates[0].format('YYYY-MM-DD'),
      dataFim: dates[1].format('YYYY-MM-DD'),
    });
  };

  return (
    <div className="flex items-center gap-3 flex-shrink-0">
      <span className="text-xs text-white/60 uppercase tracking-wider font-semibold whitespace-nowrap">
        Período do resumo
      </span>
      <RangePicker
        format="DD/MM/YYYY"
        value={[dayjs(periodo.dataInicio), dayjs(periodo.dataFim)]}
        onChange={handleChange}
        disabledDate={current => current && current > dayjs().endOf('day')}
        className="[&_.ant-picker-input>input]:text-sm"
        classNames={{ popup: { root: 'fluxo-caixa-resumo-picker' } }}
      />
    </div>
  );
}
